export default __webpack_public_path__ + "static/media/CNo.12-0.f46b4136.jpg";